import {Action, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import axios from 'axios';

@Module({namespaced: true, stateFactory: true})
export default class PriceSearch extends VuexModule {
  filters = {
    initialPayment: '',
    contractLength: 60,
    annualMileage: 10,
    min_price: '',
    max_price: '',
  };

  contractLengths = [24, 36, 48, 60];
  annualMileages = [10, 20, 30, 40, 50];
  contractLength = 60;
  annualMileage = 10;
  prinp2 = 1;
  m = 1;
  initialPaymentPercent = 0;
  model = null;

  /**************************************************
   * Getters
   **************************************************/

  get requestConfig() {
    return {
      params: this.filters
    }
  }


  get getContractLengths() {
    return this.contractLengths;
  }

  get getAnnualMileages() {
    return this.annualMileages;
  }

  get getContractLength() {
    return this.contractLength;
  }

  get getAnnualMileage() {
    return this.annualMileage;
  }

  get getInitialPaymentPercent() {
    return this.initialPaymentPercent;
  }

  get getM() {
    return this.m;
  }

  get getPrinp2() {
    return this.prinp2;
  }

  get getModel() {
    return this.model;
  }

  /**************************************************
   * Mutations
   **************************************************/

  @Mutation
  setFilters(filters) {
    if(filters){
      this.filters = filters;
    }
  }

  @Mutation
  setContractLengths(contractLengths) {
    this.contractLengths = contractLengths;
  }

  @Mutation
  setAnnualMileages(annualMileages) {
    this.annualMileages = annualMileages;
  }

  @Mutation
  setContractLength(contractLength) {
    this.contractLength = contractLength;
    this.filters.contractLength = contractLength;
  }

  @Mutation
  setAnnualMileage(annualMileage) {
    this.annualMileage = annualMileage;
    this.filters.annualMileage = annualMileage;
  }

  @Mutation
  setModel(model) {
    this.model = model;
  }

  @Mutation
  setInitialPaymentPercent(initialPaymentPercent) {
    this.initialPaymentPercent = initialPaymentPercent;
  }

}
